import React, {
	useEffect, useState
}from "react"
import {
	Input, Modal, Form, Tag, Tooltip, Menu, Divider, Popconfirm 
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	Scrollbars
}from "react-custom-scrollbars"
import {
	reOrgAppealMissionsActions
}from "../store/actions"
import 'antd/lib/divider/style/index.css'
import "antd/lib/popconfirm/style/index.css"
import i18n from '../localization'
import i18nGlobal from '../../../../../localization'
import { CustomInput }from "../../../../../components/CustomInput"
import UploadFile from "../../../../UploadFile"
import moment from "moment"
import SignedIcon from "../../../../../../public/signedIcon.png"
import CustomButton from "../../../../../components/ButtonCustom"
import { managementActions } from "../../../../Management/store/actions"
import "../style.css"
import { CustomSelect } from "../../../../../components/CustomSelect"
import Notifications from "../../../../../helpers/Notifications"
import Signer from "../../../../../components/Signer"
import ConvertObjectToFormData from "../../../../../helpers/convertObjectToFormData"
import CRUDIcons from '../../../../../components/CRUDIcons'
import { useDebounce }from "use-lodash-debounce"
const { SubMenu } = Menu
const { TextArea } = Input

const ReOrgAppealMissionModal = (props) => {
	const { visible, setVisible} = props
	const dispatch = useDispatch()
	const isRu = useSelector(state => state.globalReducer.isRu)
	const { readReOrgAppealMissionResult, reOrgAppealMissionActionLoading, reOrgAppealMissionActionResult, getReOrgAppealMissionFileLoading } = useSelector((state) => state.reOrgAppealMissionReducer)
	const user = useSelector((state) => state.userReducer.user)
	const orgExecutors = useSelector((state) => state.managementReducer.getOrgUserListResult)
	const { systemEnvironment } = useSelector((state) => state.userReducer)
	const [updateMode, setUpdateMode] = useState(false)

	const [responseId, setResponseId] = useState(null)
	const [valuesToSign, setValuesToSign] = useState(null)
	const [valuesSignatures, setValuesSignatures] = useState(null)
	const [isSigning, setIsSigning] = useState(false)

	const [form] = Form.useForm()

	const answerStatus = { submitted : '1', registered : '2', fulfilled : '3' }
    const answerStatusColor = { 1 : "#F1D0D6", 2 : "#CEEEFC", 3 : "#D2FFCB" }

	const maxNumberOfFiles = 5
	const [notify, setNotify] = useState("")
	const fileNotification = useDebounce(notify, 500)

	//#region Initialization
	useEffect(() => {
		dispatch(managementActions.getOrgUserList())
		return () => {
			handleCancel()
		}
	},[])

	useEffect(() => {
		if (readReOrgAppealMissionResult){
			form.setFieldsValue({
				CreationDate   : moment(readReOrgAppealMissionResult.creationDate).format("DD.MM.YYYY"),
				EndDueDate 	: moment(readReOrgAppealMissionResult.endDueDate).format("DD.MM.YYYY"),
				AppealRegNumber  : readReOrgAppealMissionResult.appealRegNumber,
				MissionText : readReOrgAppealMissionResult.missionText,
				SenderFullName : readReOrgAppealMissionResult.senderFullName,
				SenderOrgFullName : isRu 
									? readReOrgAppealMissionResult.senderOrgFullName.name
									: readReOrgAppealMissionResult.senderOrgFullName.nameBel
									  ?? readReOrgAppealMissionResult.senderOrgFullName.name,  
				MissionFiles : readReOrgAppealMissionResult.missionFiles,
			})
			const initialValues = {};
			readReOrgAppealMissionResult.reOrgAppealMissionForReOrgs?.forEach((response) => {
				initialValues[`SEDNumber${response.id}`] = response.sedNumber;
				initialValues[`EndDate${response.id}`] = moment(response.endDate).format("DD.MM.YYYY");
				initialValues[`RegistrationDate${response.id}`] = moment(response.registrationDate).format("DD.MM.YYYY");
				initialValues[`ReceiverOrgFullName${response.id}`] = isRu 
																	 ? response.receiverOrgFullName.name
																	 : response.receiverOrgFullName.nameBel
																	   ?? response.receiverOrgFullName.name;
				initialValues[`ResponseText${response.id}`] = response.responseText; 
				initialValues[`ResponseTextSigner${response.id}`] = response.responseTextSigner;
				initialValues[`Status${response.id}`] = isRu 
														? response.status.name
														: response.status.nameBel
														  ?? response.status.name;
				initialValues[`Executor${response.id}`] = response.executor?.id;
				initialValues[`ResponseFiles${response.id}`] = response.responseFiles;
			});
			form.setFieldsValue(initialValues);
			setVisible(true)
		}
	}, [readReOrgAppealMissionResult])

	useEffect(() => {
		if (readReOrgAppealMissionResult){
			form.setFieldsValue({
				SenderOrgFullName : isRu 
									? readReOrgAppealMissionResult.senderOrgFullName.name
									: readReOrgAppealMissionResult.senderOrgFullName.nameBel
									  ?? readReOrgAppealMissionResult.senderOrgFullName.name
			})
			const initialValues = {};
			readReOrgAppealMissionResult.ReOrgAppealMissionForReOrgs?.forEach((response) => {
				initialValues[`ReceiverOrgFullName${response.id}`] = isRu 
																	 ? response.receiverOrgFullName.name
																	 : response.receiverOrgFullName.nameBel
																	   ?? response.receiverOrgFullName.name;
				initialValues[`Status${response.id}`] = isRu 
														? response.status.name
														: response.status.nameBel
														  ?? response.status.name;
			})
		}
	}, [isRu])
	//#endregion

	//#region MessageHandle
	useEffect(() => {
		const actionResultArray = Object.entries(reOrgAppealMissionActionResult)
		const noticeKeyTrue = actionResultArray.find(([_, value]) => value === true)?.[0]
		if(noticeKeyTrue) {
			Notifications.successNotice(i18n.reOrgAppealMissionActionMessage[noticeKeyTrue][isRu], '', 5)
			handleCancel()
		} else if(actionResultArray.find(([_, value]) => value === false)?.[0]){
			Notifications.errorNotice(i18n.noDataChange[isRu], '', 5)
			handleCancel()
		}
	}, [reOrgAppealMissionActionResult])

	useEffect(() => {
		if (fileNotification){
			Notifications.errorNotice(fileNotification, '', 10)
			setNotify("")
		}
	}, [fileNotification])
	//#endregion

	//#region CreateResponse

	useEffect(() => {
		if(valuesSignatures){
			const formData = new FormData()
			const values = form.getFieldsValue()
			const formValues = {
				ReOrgAppealMissionForReOrgId : responseId,
				ResponseText : values[`ResponseText${responseId}`],
				ResponseFiles : values[`ResponseFiles${responseId}`]?.map((file) => { return file.originFileObj }),
				Signature : valuesSignatures.ResponseTextSignature,
				ResponseFileSignatures : valuesSignatures.ResponseFilesSignatures
			}
			ConvertObjectToFormData(formData, formValues)
			dispatch(reOrgAppealMissionsActions.CreateReOrgAppealMissionResponse(formData))
			setIsSigning(false) 
		}
	}, [valuesSignatures])

	function createResponseForReOrgAppealMission(id){
		setResponseId(id)
		setValuesSignatures(null)
		form.validateFields().then((values) => {
			if (systemEnvironment.ecpEnabled){
				setIsSigning(true)
				setValuesToSign({
					ResponseFiles: values[`ResponseFiles${id}`],
					ResponseText: values[`ResponseText${id}`]
				})
			} else {
				setValuesSignatures({})
			}
		})
	}
	//#endregion

	//#region RenderFunc
	function signerInfoItem(signerInfo){
		return (
		  <Tooltip 
			title={i18n.signer[isRu].format(signerInfo)}
			overlayInnerStyle={{ whiteSpace: 'pre-line' }}
			className="signed_icon"
		  >
			<img src={SignedIcon}/>
		  </Tooltip>
		)
	}

	function getAllFilesLabel(label, id, isResponse){
		return(<label className="allReOrgAppealMissionFilesLabel">
					<span>
						{label}
					</span>
					<span
						className="downloadAllReOrgAppealMissionFilesLabel"
						onClick={ () => {
							if (!getReOrgAppealMissionFileLoading){
								isResponse
								? dispatch(reOrgAppealMissionsActions.GetReOrgAppealMissionResponseFiles({
									ReOrgAppealMissionForReOrgId: id
								}, i18n.reOrgAppealMissionResponseZipFileName[isRu]))
								: dispatch(reOrgAppealMissionsActions.GetReOrgAppealMissionFiles({ 
									ReOrgAppealMissionId: id 
								}, i18n.reOrgAppealMissionZipFileName[isRu]))
							}
						}}
					>
						<Tooltip title={i18n.promptTextForDownloadAppealsZipFile[isRu]}>
							<div className="allReOrgAppealMissionFilesLabel">
								<span>
									{CRUDIcons.download()}
								</span>
								<span>
									{i18n.downloadAllFiles[isRu]}
								</span>
							</div>
						</Tooltip>
					</span>
				</label>)
	}
	//#endregion

	//#region ResponseForm
	function getReOrgAppealMissionAnswer(answer){
		const readOnly = user.reOrg.id !== answer.receiverOrgFullName.id
		const statusSubmitted = answer.status.code === answerStatus.submitted 
		const statusRegistered = answer.status.code === answerStatus.registered
		const statusFulfilled = answer.status.code === answerStatus.fulfilled

		const uploadFileProps = statusRegistered && !readOnly 
								? {
									removeFromList: true
								} 
								: {
									download: true,
									getTransmittalFile:(file) => downloadReOrgAppealMissionResponseFile(file),
								}

		const answerTitle = (answer) => {
			return (<div className="reOrgAppealMissionAnswerTitle">
				<label> 
					{ isRu 
					  ? answer.receiverOrgFullName.name
					  : answer.receiverOrgFullName.nameBel
						?? answer.receiverOrgFullName.name} 
				</label>
				{statusFulfilled &&
				<label className="responseTitle">
					{CRUDIcons.download(() => exportReOrgAppealMissionResponse(answer.id))}
				</label>}
				<Tag color={answerStatusColor[answer.status.code]}>
					{ isRu 
					  ? answer.status.name
					  : answer.status.nameBel
						?? answer.status.name }
				</Tag>
			</div>)
		}

		const answerForm = (answer) => {
			return (
				<div>
					<Form.Item
						label={ i18n.filtersNames[isRu][2] }
						name={`Executor${answer.id}`}
						rules={ [{ 
							required: !readOnly && !statusFulfilled,
							message: i18n.enterExecutorMessage[isRu] 
						}] }
					>
						<CustomSelect
							value={ form.getFieldValue(`Executor${answer.id}`) }
							disabled = {readOnly || statusFulfilled}
							onChange={ (executorId) => {
								const selectValue={}
								selectValue[`Executor${answer.id}`] = executorId
								form.setFieldsValue(selectValue) 
								compareFieldsForUpdateMode(answer.executor?.id, answer.sedNumber, answer.id)
							}} 
							placeholder={ i18n.appealExecutorSelect[isRu] }
							options = {(readOnly 
										? [{
											id: answer.executor.id,
											fullName: answer.executor.fullName
										}] 
										: orgExecutors)?.map((user) => {
								return {
									label : user.fullName,
									value : user.id
								}
							})}
						/>
					</Form.Item>
					<Form.Item
						label={ i18n.SEDNumber[isRu] }
						name={`SEDNumber${answer.id}`}
						onChange={ (sedNum) => {
							const selectValue={}
							selectValue[`SEDNumber${answer.id}`] = sedNum.target.value
							form.setFieldsValue(selectValue) 
							compareFieldsForUpdateMode(answer.executor?.id, answer.sedNumber, answer.id)
						}}
					>
						<CustomInput 
							placeholder={readOnly || statusFulfilled ? "" : i18n.SEDNumberPlaceholder[isRu]} 
							readOnly={readOnly || statusFulfilled}
						/>
					</Form.Item>
					{ 	
						answer.status.code !== answerStatus.submitted &&
						<Form.Item
							label={ i18n.filtersNames[isRu][3] }
							name={`RegistrationDate${answer.id}`}
						>
							<CustomInput readOnly />
						</Form.Item>
					}
					{!readOnly && (statusSubmitted || updateMode) &&
					<CustomButton 
						type="grey"
						className="reOrgAppealMissionButton"
						loading = {reOrgAppealMissionActionLoading} 
						onClick={() => regOrUpdateReOrgAppealMission(answer.id, answer.status.code)}
					>
						{ statusSubmitted 
						  ? i18n.registrationButtonLabel[isRu]
						  : i18n.editButtonLabel[isRu]}
					</CustomButton>}
					{
						!updateMode && (statusFulfilled || statusRegistered && !readOnly) &&
						<>
							<Form.Item
								noStyle
								shouldUpdate
							>
								{() => {
									return (
										<Form.Item
											label={  
												<label>
													{i18n.reOrgAppealMissionResponseText[isRu]}
													<span>
														{ answer.responseTextSigner && signerInfoItem(answer.responseTextSigner) }
													</span>
												</label>
											}
											rules={[{
												required: !readOnly && !statusFulfilled,
												message: i18n.enterResponseTextMessage[isRu]
											}]}
											name={`ResponseText${answer.id}`}
										>
											<TextArea
												readOnly={readOnly || statusFulfilled}
												autoSize={ { maxRows : 6, minRows : 3 } }
												value={ form.getFieldValue(`ResponseText${answer.id}`) }
												onChange={(text) => {
													const value = {}
													value[`ResponseText${answer.id}`] =  text.target.value
													form.setFieldsValue(value)
												}}
											/>
										</Form.Item>
									)}}
							</Form.Item>
							{ !(statusFulfilled && form.getFieldValue(`ResponseFiles${answer.id}`)?.length == 0) &&
							<Form.Item
								noStyle
								shouldUpdate
							>
								{() => {
									return (
										<Form.Item 
											name={`ResponseFiles${answer.id}`}
											label={ form.getFieldValue(`ResponseFiles${answer.id}`)?.length > 1 && statusFulfilled
													? getAllFilesLabel(i18n.responseFiles[isRu], answer.id, true)
													: i18n.responseFiles[isRu]
											}
											valuePropName="fileList"
										>
											<UploadFile
												{...uploadFileProps}
												listType="text"
												className="reOrgAppealMissionFiles"
												fileList={form.getFieldValue(`ResponseFiles${answer.id}`)}
												onChangeCustom={ (val) => {
													const value = {}
													value[`ResponseFiles${answer.id}`] =  val.fileList.slice(0, maxNumberOfFiles) 
													form.setFieldsValue(value)
													if(val.fileList.length > maxNumberOfFiles){
														setNotify(i18n.filesMaxCountErrorNotice[isRu].format(maxNumberOfFiles))
													}
												}}
												
											/>
										</Form.Item>
									)}}
							</Form.Item>}
							{statusFulfilled &&
							<Form.Item
								label={ i18n.filtersNames[isRu][5] }
								name={`EndDate${answer.id}`}
							>
								<CustomInput readOnly />
							</Form.Item>}
							{statusRegistered && !readOnly &&
							<Popconfirm
								cancelText={ i18nGlobal.no[isRu] }
								okText={ i18nGlobal.yes[isRu] }
								title={ i18n.createResponseForReOrgAppealMissionMessage[isRu] }
								onCancel={ () => {return null} }
								onConfirm={ () => createResponseForReOrgAppealMission(answer.id) }
							>
								<CustomButton 
									type="turquoise" 
									className="reOrgAppealMissionButton"
									loading = {reOrgAppealMissionActionLoading || isSigning}
								>
										{ i18n.addAnswerButtonLabel[isRu] }
								</CustomButton>
							</Popconfirm>}
						</>
						
					}
				</div>
			)
		}
		
		if(!readOnly)
			return(<>
					<Divider plain> 
						<div className="reOrgAppealMissionModalTitle">
							<span>{i18n.formLabelByStatusCode[isRu]
								[
									statusSubmitted 
									? 0
									: statusRegistered && updateMode 
									  ? 2
									  : 1
								]
							}</span>
							{statusFulfilled &&
							<span className="responseTitle">
								{CRUDIcons.download(() => exportReOrgAppealMissionResponse(readReOrgAppealMissionResult?.reOrgAppealMissionForReOrgs[0].id))}
							</span>}
						</div>
					 </Divider>
					{answerForm(answer)}
				   </>)
		if(readOnly && statusSubmitted)
			return(answerTitle(answer))
		if(readOnly && !statusSubmitted)
			return(
				<SubMenu
					key={ `reOrgAppealMissionAnswer${ answer.id }` }
					className="reOrgAppealMissionFormSubMenu"
					title={answerTitle(answer)}
			   	>
					{answerForm(answer)}
			   	</SubMenu>)
	}
	//#endregion

	//#region Functions
	function regOrUpdateReOrgAppealMission(id, statusCode){
		form.validateFields().then((values) => {
			dispatch(reOrgAppealMissionsActions[
				statusCode === answerStatus.submitted 
				? 'RegisterReOrgAppealMission'
				: 'UpdateReOrgAppealMissionByReceiver' 
				
			]({
				ReOrgAppealMissionForReOrgId : id,
				ExecutorId : values[`Executor${id}`],
				SEDNumber : values[`SEDNumber${id}`], 
			}))
		})
	}
	
	function compareFieldsForUpdateMode(executorId, sedNumber, id){
		if(form.getFieldValue(`Executor${id}`) === executorId 
		   && form.getFieldValue(`SEDNumber${id}`) === (sedNumber ? sedNumber : ""))
		   setUpdateMode(false)
		else 
		   setUpdateMode(true)
	}

	function downloadReOrgAppealMissionFile(file){
		if (!getReOrgAppealMissionFileLoading){
			dispatch(reOrgAppealMissionsActions.GetReOrgAppealMissionFile({
				fileId: file.id
			}, file))
		}
	}

	function downloadReOrgAppealMissionResponseFile(file){
		if(!getReOrgAppealMissionFileLoading){
			dispatch(reOrgAppealMissionsActions.GetReOrgAppealMissionResponseFile({
				fileId: file.id
			}, file))
		}
	}

	function exportReOrgAppealMission(){
		if(!getReOrgAppealMissionFileLoading){
			dispatch(reOrgAppealMissionsActions.ExportReOrgAppealMission({
				reOrgAppealMissionId : readReOrgAppealMissionResult.id,
			}, i18n.reOrgAppealMissionTextForAppeal[isRu].format(readReOrgAppealMissionResult?.appealRegNumber)))
		}
	}

	function exportReOrgAppealMissionResponse(answerId){
		if(!getReOrgAppealMissionFileLoading){
			dispatch(reOrgAppealMissionsActions.ExportReOrgAppealMission({
				reOrgAppealMissionForReOrgId : answerId
			}, i18n.reOrgAppealMissionResponseTextForAppeal[isRu].format(readReOrgAppealMissionResult?.appealRegNumber)))
		}
	}

	function handleCancel(){
		setVisible(false)
		setUpdateMode(false)
		setValuesToSign(null)
		setValuesSignatures(null)
		setIsSigning(false)
		form.resetFields()
		dispatch(reOrgAppealMissionsActions.ClearReOrgAppealMissionCRUDValues())
	}
	//#endregion

	return (
		<Modal
			destroyOnClose
			footer={ null }
			title={ <div className="reOrgAppealMissionModalTitle">
						<span>
							{i18n.headerReOrgAppealMissions[isRu]}
						</span>
						<span>
							{CRUDIcons.download(exportReOrgAppealMission)}
						</span>
					</div> }
			visible={ visible }
			className="reOrgAppealMissionModal"
			width={ 800 }
			onCancel={ handleCancel }
		>
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 650 }
			>
				<Form
					form={ form }
					labelAlign="left"
					layout="vertical"
					className="reOrgAppealMissionModalForm"
				>
					<Form.Item
						label={ i18n.tableItems[isRu][2] }
						name="CreationDate"
					>
						<CustomInput readOnly />
					</Form.Item>
					<Form.Item
						label={ i18n.tableItems[isRu][4] }
						name="EndDueDate"
					>
						<CustomInput readOnly />
					</Form.Item>
					<Form.Item
						label={ i18n.tableItems[isRu][7] }
						name="AppealRegNumber"
					>
						<a
							onClick={ () => {
								window.open(`/appeal/${ readReOrgAppealMissionResult?.reOrgAppealId }`, "_blank");
								handleCancel()
							} }
						>
							{ `№${ form.getFieldValue("AppealRegNumber") }` }
						</a>
					</Form.Item>
					<Form.Item
						label={ i18n.reOrgAppealMissionReferringOrganization[isRu] }
						name="SenderOrgFullName"
					>
						<CustomInput readOnly />
					</Form.Item>
					<Form.Item
						label={
							<label>
								{i18n.reOrgAppealMissionText[isRu]}
								<span>
									{readReOrgAppealMissionResult?.missionTextSigner && signerInfoItem(readReOrgAppealMissionResult.missionTextSigner)}
								</span>
							</label>
						}
						name="MissionText"
					>
						<TextArea
							readOnly
							autoSize={ { maxRows : 5,
								minRows : 3 } }
						/>
					</Form.Item>
					<Form.Item
						label={ i18n.reOrgAppealMissionReferringPerson[isRu] }
						name="SenderFullName"
					>
						<CustomInput readOnly />
					</Form.Item>
					<Form.Item
						label={ form.getFieldValue("MissionFiles")?.length > 1 
								? getAllFilesLabel(i18n.reOrgAppealMissionFiles[isRu], readReOrgAppealMissionResult?.id, false)
								: i18n.reOrgAppealMissionFiles[isRu]
						}
						name="MissionFiles"
						valuePropName="fileList"
					>
						<UploadFile
							download
							className="reOrgAppealMissionFiles"
							fileList={ form.getFieldValue("MissionFiles") }
							getTransmittalFile={(file) => downloadReOrgAppealMissionFile(file) }
							listType="text"
						/>
					</Form.Item>
					<Menu
						mode="inline"
					>
						{ 
							readReOrgAppealMissionResult?.reOrgAppealMissionForReOrgs?.map((answer) => {
								return getReOrgAppealMissionAnswer(answer)
							})
						}
					</Menu>
					<Signer 
						values = {valuesToSign}
						setValuesSignatures = {setValuesSignatures} 
						setIsSigning ={setIsSigning}
					/>
				</Form>
			</Scrollbars>
		</Modal>
	)
}
export default ReOrgAppealMissionModal
